// btw-front/src/components/auth/OwnershipGuard.jsx
//
// `/partners/deals/:id` 전용.
//  - 관리자: 모든 딜 통과
//  - 파트너: 클라이언트는 우선 통과시키고, 서버가 같은 회사 딜인지 재검증 (api.partnerDeals.get).
//    서버에서 404/403 → 페이지가 notFound 화면 표시.
//
// 즉 본 가드는 "역할 자체가 partner/admin 인지" 만 검사. 실 소유 검증은 서버.
// (이전 디자인 단계 mockDeals.find 기반 가드는 백엔드 도입과 함께 폐기)

import React from "react";
import { Navigate } from "react-router-dom";
import { usePartnerSession } from "../../context/PartnerSessionContext";

export default function OwnershipGuard({ children }) {
  const { role } = usePartnerSession();
  if (role === "admin" || role === "partner") return children;
  return <Navigate to="/partners" replace />;
}
